import { useSyncExternalStore } from 'react'

/**
 * Ist das ein Gerät, auf dem sich dieses Board nicht bearbeiten lässt?
 *
 * Præsto ist eine Werkbank: Frames aufziehen, Elemente ausrichten, Leisten am
 * Objekt bedienen. Das setzt Zeigegenauigkeit und Fläche voraus. Auf einem
 * Telefon fehlt beides — und die Panels links und rechts sind dort ohnehin
 * ausgeblendet, es bliebe eine Bearbeitung ohne Gliederung und ohne Ebenen.
 *
 * **Zuschauen** dagegen funktioniert dort gut und ist der häufigere Fall: Ein
 * Gast bekommt einen Link oder einen QR-Code und sieht sich die Vorführung an.
 * Genau diese Trennung stellt der Haken her.
 *
 * Zwei Bedingungen, beide nötig: ein grober Zeiger (Finger statt Maus) *und*
 * ein schmales Fenster. Ein Tablet mit Tastatur am Schreibtisch ist breit genug;
 * ein schmal gezogenes Browserfenster am Rechner hat eine Maus. Nur wo beides
 * zusammenkommt, ist es wirklich ein Telefon.
 */
const ABFRAGE = '(pointer: coarse) and (max-width: 820px)'

function abonnieren(melden: () => void): () => void {
  const liste = window.matchMedia(ABFRAGE)
  liste.addEventListener('change', melden)
  return () => liste.removeEventListener('change', melden)
}

export function useSmallScreen(): boolean {
  return useSyncExternalStore(
    abonnieren,
    () => window.matchMedia(ABFRAGE).matches,
    // Auf dem Server gibt es kein Fenster; dort gilt der gewöhnliche Fall.
    () => false,
  )
}
